import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  "aria-hidden": "true",
  class: "svg-size--1 svg-fill--dark mr-1"
}
const _hoisted_3 = ["href"]




export default {
  __name: 'TagsListItem',
  props: {
  item: {
    type: Object,
    required: true,
  },
  removeTag: {
    type: Function,
    required: true,
  }
},
  setup(__props) {



function iconPath(iconName) {
  return `/themes/custom/promutuel/dist/icons.svg#${iconName}` 
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("label", {
    onClick: _cache[0] || (_cache[0] = $event => (__props.removeTag(__props.item))),
    id: __props.item.id,
    class: "tag-item mr-2"
  }, [
    (__props.item.id === 'search-box')
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [
          _createElementVNode("use", {
            href: iconPath('recherche')
          }, null, 8 /* PROPS */, _hoisted_3)
        ]))
      : _createCommentVNode("v-if", true),
    _createTextVNode(" " + _toDisplayString(__props.item.label), 1 /* TEXT */)
  ], 8 /* PROPS */, _hoisted_1))
}
}

}